<template>
  <b-col sm="12" lg="4">
    <div class="animated fadeIn">
      <b-card class="picture-div">
        <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <div class="container">
            <div class="outer">
              <img :src="userPic" class="img-circle" alt="www.fibernode.com" />

              <div class="inner">
                <UpdatePicture :user="userId" @picChanged="changePic" class="modalPicture" />
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </b-col>
</template>


<script>
import UpdatePicture from "./UpdatePicture";

export default {
  name: "ProfilePicture",
  components: {
    UpdatePicture
  },
  data() {
    return {
      loadingData: true,
      uploading: false,
      userPic: "",
      userId: null,
      file: null,
      fakeCache: 1
    };
  },
  methods: {
    changePic(value) {
      console.log(value);
      this.userPic = value + "?version=1" + this.fakeCache;
      this.fakeCache++;
    }
  },
  mounted() {
    this.userPic = localStorage.getItem("viavi_user_picture");
    this.userId = localStorage.getItem("viavi_user");
    this.loadingData = false;
  }
};
</script>

<style scoped>
.sk-double-bounce {
  height: 12px !important;
  width: 12px !important;
  line-height: 55px;
  margin: auto;
}
.card-body {
  min-height: 480px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  display: block;
  margin: auto;
}

.outer {
  max-width: 30vh !important; /* any size */
  max-height: 30vh !important; /* any size */
  margin: auto;
  position: relative;
}

.inner {
  width: 7vh;
  height: 7vh;
  border-radius: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
